import { SortOrder } from "../sort-order";

export class DefaultPropertyTypeFilters {
  name: string;
  unit: string;
  dataType: string;
  sortField: string;
  sortOrder: SortOrder;
}
